const _ = require('lodash');

module.exports = function (atm, shopLocatorService, storePickerService, bwsNotificationService) {
    return {
        strict: 'E',
        transclude: true,
        scope: {},
        link(scope) {

            scope.storePicker = storePickerService;

            scope.getStoreInfoUrlParams = function (store) {
                return shopLocatorService.generateUrlParamsForStoreInfos(store || scope.storePicker.store);
            };

            scope.searchStores = (store) => {
                shopLocatorService.listSupermarkets({
                    Max: 15,
                    Latitude: store.Latitude,
                    Longitude: store.Longitude
                }).then(function (response) {
                    scope.storesList = _.filter(response.Stores, { IsClickAndCollectEnabled: true });
                });
            };

            scope.setSelectedStore = function (store) {
                storePickerService.setPickupByStoreNo(store.StoreNo).then((fulfilmentInfo) => {
                    scope.storePicker.store = fulfilmentInfo.ClickAndCollectDetails;

                    const atmData = {
                        event: 'BWSAUupdateStorePreferencePickup',
                        store: {
                            StoreNo: fulfilmentInfo.ClickAndCollectDetails.FulfilmentStoreID,
                            Postcode: fulfilmentInfo.ClickAndCollectDetails.AddressPostalCode,
                            Name: fulfilmentInfo.ClickAndCollectDetails.FulfilmentStoreName
                        },
                        fulfilmentInfo
                    };

                    atm.pushWithStoreMapper(atmData);

                    bwsNotificationService.success(`You\'re browsing <strong>BWS ${scope.storePicker.store.FulfilmentStoreName}</strong>.`);
                });
            };
        },
        template: require('./click-and-collect-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help/click-and-collect-directive.js
 **/